import React, { Component } from 'react'
import "./industrialChain.scss"
import Header from '../../components/Header/header'
import Footer from '../../components/Footer/footer'

export default class industrialChain extends Component {

    state = {
        showMore:false,
        arr:[
            {},{},{},{},{},
            {},{},{},{},{},
            {},{},{},{},{},
            {},{},{},{},{}
        ]
    }

    componentWillMount(){
        window.scroll(0,0);
    }

    gotoPage=(page)=>{
        this.props.history.push(page);
    }

    render() {
        return (
            <div className='industrialChain'>
                <Header type={3} />
                <div className='head'>
                    <div className='cen'>
                        <div className='hmain'>
                            <div className='hname'>
                                <p>当前位置：</p>
                                <p className='i_point' onClick={()=>{this.gotoPage('/')}}>首页</p>
                                <img alt="" src="/www/assets/imgs/xiaji.png" />
                                <p className='i_point' onClick={()=>{this.gotoPage('/industrialMap')}}>产业图谱</p>
                                <img alt="" src="/www/assets/imgs/xiaji.png" />
                                <p>产业链</p>
                            </div>

                            <div className='hbox'>
                                <div className='hdiv'>
                                    <h2>区域范围：</h2>
                                    <div className={this.state.showMore?'hflex hauto':'hflex'}>
                                        <div className='chosn'>全部</div>
                                        <div>玄武区</div>
                                        <div>江宁区</div>
                                        <div>栖霞区</div>
                                        <div>东城区</div>
                                        <div>玄武区</div>
                                        <div>江宁区</div>
                                        <div>栖霞区</div>
                                        <div>东城区</div>
                                        <div>玄武区</div>
                                        <div>江宁区</div>
                                        <div>栖霞区</div>
                                        <div>东城区</div>

                                        <div className='more' onClick={()=>{this.setState({showMore:!this.state.showMore})}}>
                                            <p>{this.state.showMore?"收起":"更多"}</p>
                                            <img alt="" src={this.state.showMore?"/www/assets/imgs/gengduo2.png":"/www/assets/imgs/gengduo.png"} />
                                        </div>
                                    </div>
                                </div>
                                <div className='hdiv'>
                                    <h2>产业类型：</h2>
                                    <div className='hflex'>
                                        <div className='chosn'>人工智能</div>
                                        <div>新一代通信技术</div>
                                        <div>新能源汽车</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='ibox'>
                    <div className='cen'>
                        <div className='main'>
                            <div className='left'>

                            </div>
                            <div className='right'>
                                <div className='top'>
                                    <h2>产业链共计 <span>97</span> 环节 企业共计<span>3430</span>家</h2>
                                    <h2><span>本环节</span>  企业共计<span>390</span>家</h2>
                                </div>
                                <table>
                                    <tr className='ptr'>
                                        <th>序号</th>
                                        <th>企业名称</th>
                                        <th>特色标签</th>
                                        <th>评级</th>
                                    </tr>
                                    {
                                        this.state.arr.map((item,index)=>{
                                            return <tr key={index}>
                                                        <td>{index+1}</td>
                                                        <td>北京市商汤科技开发有限公司</td>
                                                        <td>高新技术企业</td>
                                                        <td>84.21</td>
                                                    </tr>
                                        })
                                    }
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
}
